export default function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) return savedPosition;

  if (to.hash) {
    if (document.querySelector(to.hash)) return { selector: to.hash };
    return false;
  }

  return { x: 0, y: 0 };
}
